export const isPrerender = userAgent =>
    userAgent.indexOf('Prerender (+https://github.com/prerender/prerender)') >
    -1;
